import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { GrantsModel } from "../../../../../Models/GrantsModel";
import FavGrantsModelInfo from "../FavGrantsModalInfo";
import './styles.css';
import { IOpportunitiesProjects } from "../../../../../Interfaces/IOpportunitiesPanels";
import { TextField } from "@mui/material";

interface ShowModalProps {
    show: boolean,
    toggleShowModal: () => void,
    grants?: GrantsModel,
    projects?: IOpportunitiesProjects[],
}

const ModalFavGrants = ({ show, toggleShowModal, grants, projects }: ShowModalProps) => {
    const [justification, setJustification] = useState("");
    const [projectIndex, setProjectIndex] = useState<number>(0);

    useEffect(() => {
        if (projects && projects?.length > 0) {
            setJustification(projects[0].justification);
            setProjectIndex(0);
        }
    }, [projects]);

    return (
        <Modal show={show} onHide={toggleShowModal} size="lg">
            <Modal.Header closeButton>
                <div className="d-flex justify-content-center">
                    <h3 className="blue text-center w-100 font-weight-bold">{grants?.title}</h3>
                </div>
            </Modal.Header>
            <Modal.Body>
                <FavGrantsModelInfo grants={grants} />
                <h5 className="mx-2 mb-2 line-body mb-4 text-observation font-weight-bold">Projetos:</h5>
                <div className="mx-2">
                    <div className="d-flex align-content-center">
                        {projects?.map((projectList, ind) => {
                            return (
                                <div key={ind} >
                                    {projectList &&
                                        <span
                                            className={`projects-span-modal p-2 cursor-pointer ${projectIndex == ind && "active-justification"}`}
                                            onClick={() => {
                                                setProjectIndex(ind);
                                                setJustification(projectList.justification)
                                            }}
                                        >
                                            {projectList.projectName ?? ""}
                                        </span>
                                    }
                                </div>
                            )
                        })}
                    </div>
                    <div className="justification-container">
                        <h5 className="line-body text-observation">
                            <span className="mb-2 mt-2 font-weight-bold">Justificativa do Projeto</span>
                            <div className="mt-2">
                                <TextField multiline maxRows={1} className="text-area-justification w-100 form-control" value={justification ?? ""} />
                            </div>
                        </h5>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )

}
export default ModalFavGrants